<template>
  <div class="home">
    <van-image width="100%" height="9rem" :src="imgLogo" />

        <van-swipe :autoplay="3000" @change="onChangeImageDrink">
          <van-swipe-item v-for="(image, index) in imgDrinkList" :key="index">
            <div class="img-box">
            <img :src="image" @load="onImageLoad" :style="imgStyle" class="auto-landscape"  @click="previewImg(imgDrinkList, index)" />
              </div>
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator" style="padding-top:1rem">{{ indexOfDrinkImage + 1 }}/{{imgDrinkList.length}}</div>
          </template>
        </van-swipe>

  
    <div data-v-3c9e1394="" class="product-div" style="text-align: center;">
      <p data-v-3c9e1394=""
        style="text-align: center;padding-top: 0rem;padding-bottom: 0rem;font-size: .8rem;color:rgb(102, 102, 102)">
        成品展示</p>
    </div>
    <div data-v-3c9e1394="" class="sy-row-div" style="position: relative;">
      <h3 data-v-3c9e1394="" style="line-height: 1em;
    font-size: 1rem;
    padding-bottom: 10px;
    text-align: left;
    padding-left: 1rem;
    color: rgb(102, 102, 102);">
        {{ healthyDrink }}</h3>
    </div>

    <van-cell-group  style="text-align: left">
      <van-cell title="溯源码" :value="traceCode" align="left" />
      <van-cell title="商品编码" :value="productCode" align="left" style="background: #fafafa"  is-link  @click="openGoodsDetails(productCode)" />
      <van-cell title="批 号" :value="batchNo" align="left" />
      <van-cell title="规 格" :value="productSpec" align="left" style="background: #fafafa" />
      <van-cell title="等 级" :value="productLevel" align="left"  />
      <van-cell title="生产企业" value="湖北润康药姑山中药饮片有限公司" align="left" style="background: #fafafa"/>
      <van-cell title="产 地" :value="materialPlace" align="left"  />
      <van-cell title="报告日期" :value="inspectDate" align="left"  style="background: #fafafa"/>
    </van-cell-group>

    <van-collapse style="padding-top:1rem" v-model="activeName" accordion>
     <van-collapse-item title="原料药材" name="1">
        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;基原信息&nbsp;&nbsp;</div>
        </div>
        <van-cell-group>
          <van-cell title="基原" :value="material" align="left" style="background: #fafafa" />
        </van-cell-group>
        <div v-html="growthCycle" @click="handleContainerClick($event)" ref="supplierContent"></div>
        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;其他信息&nbsp;&nbsp;</div>
        </div>
        <van-cell-group>
          <van-cell title="农药使用" :value="pesticideUse" align="left" />
          <van-cell title="种植日期" :value="plantTime" align="left" style="background: #fafafa" />
          <van-cell title="初加工方法" align="left" >
            <template #default>
              <span v-html="primaryProcessingMethod"></span>
            </template>
          </van-cell>
        </van-cell-group>

      </van-collapse-item>
      <van-collapse-item title="饮片生产" name="2">

        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;投料&nbsp;&nbsp;</div>
        </div>
        <van-cell-group>
          <van-cell title="原料" :value="healthyDrinkMaterial" align="left" />
          <van-cell title="原料批次" :value="materialBatchNo" align="left" style="background: #fafafa" />
          <van-cell title="规格" :value="materialSpec" align="left" />
          <van-cell title="生产日期" :value="packageDate" align="left" style="background: #fafafa" />
        </van-cell-group>

        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;成品信息&nbsp;&nbsp;</div>
        </div>
        <van-cell-group>
          <van-cell title="品种名称" :value="healthyDrink" align="left" />
          <van-cell title="成品批次" :value="batchNo" align="left" style="background: #fafafa" />
          <van-cell title="规格" :value="productSpec" align="left"  />
        </van-cell-group>

        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;工艺流程&nbsp;&nbsp;</div>
        </div>
        <van-cell-group v-if="imgTechFlowList == 0" >
          <van-cell title="暂无流程图" style="text-align:center" />
        </van-cell-group>
        <van-swipe :autoplay="3000" @change="onChangeImageTechFlow" >
          <van-swipe-item v-for="(image, index) in imgTechFlowList" :key="index">
            <img v-lazy="image" style=" width: 50%;height: 100%;object-fit: contain;" @click="previewImg(imgTechFlowList, index)" />
          </van-swipe-item>
          <template #indicator v-if="imgTechFlowList > 0">
            <div class="custom-indicator"  >{{ indexOfTechFlowImage + 1 }}/{{imgTechFlowList.length}}</div>
          </template>
        </van-swipe>

        <ProcessFlowViewer 
          :trace-code="traceCode"
          :autoplay="3000"
        />
      </van-collapse-item>
 
    <van-collapse-item title="质量控制" name="5">

    <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;中药材质量信息和药品检验&nbsp;&nbsp;</div>
        </div>
        <van-swipe :autoplay="3000" @change="onChangeImageQuality">
          <van-swipe-item v-for="(image, index) in imgQualityList" :key="index">
            <img v-lazy="image" style=" width: 50%;height: 100%;object-fit: contain;" @click="previewImg(imgQualityList, index)" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ indexOfQualityImage + 1 }}/{{imgQualityList.length}}</div>
          </template>
        </van-swipe>


            <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;控制过程&nbsp;&nbsp;</div>
        </div>
        <QualityDetailsViewer 
          :trace-code="traceCode"
          :autoplay="3000"/>

      </van-collapse-item>

      <van-collapse-item title="成品销售" name="3">
        <van-cell-group>
          <van-cell title="年份" :value="salesYear" align="left" style="background: #fafafa" />
          <van-cell title="具体信息" align="left" style="background: #fafafa" >
            <template #default>
              <span v-html="salesInfo"></span>
            </template>
          </van-cell>
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="企业信息" name="4">
        <van-swipe :autoplay="3000" @change="onChangeImageCert">
          <van-swipe-item v-for="(image, index) in imgCertList" :key="index">
            <img v-lazy="image" style=" width: 80%;height: 100%;object-fit: contain;" @click="previewImg(imgCertList, index)" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ indexOfCertImage + 1 }}/2</div>
          </template>
        </van-swipe>

        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;公司介绍&nbsp;&nbsp;</div>
        </div>
        <p data-v-4e231382="" data-v-5e73307c="" class="introduce-content">
          
&nbsp;&nbsp;湖北润康药业是一家集中药产、学、研和医疗器械、医药批发、冷链物流仓储、中药文化传播于一体的民营企业。旗下已先后成立了湖北润康药姑山中药饮片有限公司、湖北润康医疗科技有限公司、湖北领智冷链物流有限公司、湖北润康虎岩中药材种植有限公司等多家子公司，建有制剂、提取、中药材库、GSP仓库、动力中心、中药材晒场、研发质检楼、内检室等专业生产、研发、检测、仓储物流一体化体系。购置了国内外领先的果实类全自动洗、脱、润一体机，采用超微粉冷破壁中药现代化技术，使中药材有限资源得到极限利用。兼营医疗器械生产、药品批发零售和物流配送，范围涉及中成药、化学药制剂、抗生素、生化药品、生物制品、中药饮片、配方颗粒等。公司还建成全市首个中医药文化展览馆，成功打造出通城乃至全市中医药产业发展的形象窗口和文化名片。

集团公司具有中高级专业技术人才及市场营销管理人才占比30%，并已与湖北中医药大学建立了校企产研战略合作，并拟申报院士工作站。严格遵循“精湛、精心、精工、精品”的质量方针，按照国家GSP标准，旨在高标准、高投入地全力打造现代中医药企业和现代医药物流一流企业，为健康中国助力加油！
        </p>
        <div data-v-4e231382="" data-v-5e73307c="" class="user">
          <div data-v-4e231382="" data-v-5e73307c="" class="user-item"><img data-v-4e231382="" data-v-5e73307c=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEN0lEQVRYR+2WXWgcVRTH/2fu7Cbt3k1WothA+9BW8aHViB8VpVZE81BKq/iRVLCRku4EGxusoiA+KAqCoAWFaHc2tIp5qA+KrUVbW23RKjaKH/WlKlVEQoRUku7OpMnu3HtkGnezJjOzHwp9cV7vOf/zu+eejyFc5I8ucnz8D1B/BmznWhO6h8m4FYyVYE6CkGdgjIhOgvmQSsn30EWFWp43HGDvREp4sfXMaCeDflG5xYfxGKZF1j0O5nVVxMcZ4nkt+B1T8yoY7HkxOYIecuf7BQIIe6oLUBkAqZIDA6OGMDd7GqOCve8BJGu5YYVNnsHPaqtlV6XfAgAzk1vLRMcAmAsCMHIqbnaIou5k6B0EGiHCODMnAKwGsBZALAqMQY9rS5YhFgAIO/8RgM5QEcKgSicfCTzPOpcL5qcB7IiAcFRRtqOfHN8mCCAPQIYJMOgbbcnrw86NbH6AGK9EZYFAnZ4lj4YBnAPQEi5AXylLrgkFGHKeIs0vRNYHGRtUOvFBCEDuIEAbwgQI9JJnySfCzk3buZPBRyIAlCrSUvTLPwIBYnvc67THnwPcHCAyrtjoQF9iLDQAM4mscwLALSE2u5WVfLh0FtiGhp3/iYArKwWY8aMwqbvYK/0WjP4GnSUizu+CcfM8w30qdnYrti6fDgfwb2A7BVC5DfcTmS97rc1foItUtdjlc2YybbdTE60BVFEL8TF6E1/jVW7CAM2EA/gTsGhOlAwY9Ki2ZGRVV4XaM73CKBbuA1E3GEO6L/l6BAA3i6Jzfg4Az2kr+UzVIGEGmemVwvB+BnPpuR9QVnJfZA0IO+9nYHYMEw+rdMuWRgHEbncjDH2gHJDMdV560WfRAFnnKJjvmAXAn+oKuQS3k9cIhLDdQUBv/9u3oFIyhS4qZzi4C4amdpJWc0uDaItKy+G6Ad7MtYkZOgOgdfYydEil5fpKneB1fGGm41eAF/nGDBrTXmIVtlO5OPHa5CUibm4izcvYX9fxxP5/rFu/m4act8G4vxzQMDapbYn3qwP4q9B2djF455wxnVTifCd6L8uLrHsXWL9Rua4BnCXQg54lD/s+hp17kUBPlv2JPlVpedv8LIb/kAyyNGLuKQIvLzkpMm4AsxLAlwA3LXwSmgHpboB6wLhnbiYgp8A3oa/ldO0AAOJZ5xrF7Fesv5zOqZRsE5PuMMCb66iHAqDvVlbrh0E+Vf8JY7Z7o4I+SOARZbVsFNn8GTBW1AgwSYR7vXTykzD7qgAXHDNuu2nwai8tjxiZ/GkiXBUJQMRgPqCaRD8eWjwaZVsbQIXCvL4O0j6hDGMA2xLf1pKlugGQnVoqWPnily4IwJhQXqED/W2/1xJ8ds418MX3Old7RbxF4I6SOwPfmUw9hT75Qz2SDQHMBmCC7XYIrZcpYfyGtDxVT+CS7b8AaCRcwOT4b2QaV/kL8/6cMI+mK80AAAAASUVORK5CYII=">
            生产负责人: 韩南山
          </div>
          <div data-v-4e231382="" data-v-5e73307c="" class="user-item"><img data-v-4e231382="" data-v-5e73307c=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAC8UlEQVRYR+2Xb2hNcRjHv8/5nY2556qltSQReUNJmcgLyZspKbJakX9d996lWcpSXsgV74RkRvfMv+zNaktpKV5ICiViavZKWtJesNDObrPd3++ra8bs/v+zKTnvTud5vt/Pec7zPOccwV8+pGD/SG+5vXDRxkR+/H3/Q0RWjBailR9AhLY9f3gTBfUAtwOo/Gn6GZDbQnTEB3wPEJF4rjDZASK07AXeBsKqB8wOEFUZxQUfAatLYDriH5xHiIjJFJ8agBRcHVqvjNQTUifg/FzvaHIcIQMCdmqLHQj4n0CEU3WSAOyoV2tIVwQLCzFNl0PivSUSjIece5NjkgFc7zzJw6U0n9ASyLl4yDnyH+DfrQBFjlrkM0BqCR5L7vjp7AFBmw76g7hKv6W9lwIsnTEAAn2GTg3CElPRoXYAu1JNUXFTIDIKMrFiZwFQvw1kxDJYN9bg9CjX2wPyZroRLgqAlGYTds6Wu95KTT4FMCdhRKgmE5pzEVe+LlOW9QKAf1oAAMS0wRo0+N+o6HAQMFGA3To0dysiveVqwaLHIGsy7/0im5Air43tW4v9MmK73oW4MacQnvvJjnpnCDZn255FPYJf4sQlHfY3Tpwn3h0E7gK0Zgbgx2O3tumA7w5cr9oiewSozmaeuF6aCox33qAmNihLzgGszcW8tAC5Ok6Jy6kCqs3bC8MbBXpkSZM9OuTcyvgySlxUUW8fyFYIKkoDIjEQB3XYSVpSab8Jy6LeKi3sEmJJMRAE3ipI3VjIeZV6PWdSb/1SqWz7FsAthUFIty7z7cZ++ZJ+O2ZTJsVyveMCnACQddbH5USTPGlCzulUH6JZeyAVk93mbSbZDmJeRmZiUGzZGQ8497Pd2/ho5nNc/rxYqbJOgKtTpok816LqcKCiP1fZ/AASqtffzVZjVS0AA3+YWHB1zDmEJvmWq3n+FZikrNzhAGhagMTPhjTqkO9aPsYTsflXYLLLlaHlUCCC/r5CzIuqQKGGU/O+A2uOcjA3JZXNAAAAAElFTkSuQmCC">
            质量负责人: 吴少乐
          </div>
        </div>
        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;联系我们&nbsp;&nbsp;</div>
        </div>
        <p data-v-4e231382="" data-v-5e73307c="">网址：<a href="https://www.hbrkyy.com" target="_blank">www.hbrkyy.com</a></p>
        <p data-v-4e231382="" data-v-5e73307c="">联系电话：<a href="tel:0715-4066686">0715-4066686</a></p>
        <p data-v-4e231382="" data-v-5e73307c="">联系地址：湖北省咸宁市通城县隽水镇民主北路特8号</p>
        <div data-v-4e07b061="" data-v-4e231382="" class="sy-title topLine" data-v-5e73307c="">
          <div data-v-4e07b061="" class="sy-title-divider">&nbsp;&nbsp;地图导航&nbsp;&nbsp;</div>
        </div>
        <p><a target="_blank"
            href='https://map.baidu.com/mobile/webapp/place/detail/qt=ninf&wd=%E6%B9%96%E5%8C%97%E6%B6%A6%E5%BA%B7%E8%8D%AF%E4%B8%9A&searchFlag=bigBox&uid=154f9c8f6ff053d8611c675b&industry=life&qid=974412077800083206/showall=1&pos=5&da_ref=listclk&da_qrtp=11&da_adtp=&da_log=&da_adquery=%E6%B9%96%E5%8C%97%E6%B6%A6%E5%BA%B7%E8%8D%AF%E4%B8%9A&da_adtitle=%E6%B9%96%E5%8C%97%E6%B6%A6%E5%BA%B7%E8%8D%AF%E5%A7%91%E5%B1%B1%E4%B8%AD%E8%8D%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8-%E5%8C%97%E9%97%A8&da_adindus=%E5%87%BA%E5%85%A5%E5%8F%A3;%E9%97%A8&detail_from=list'><img
              src="../assets/map.png" style="width:95%" /></a></p>

      </van-collapse-item>
    </van-collapse>
   <div class="copyright">
      <p>技术支持：湖北润康药姑山中药饮片有限公司信息部 © {{ currentYear }}</p>
    </div>
      <climate-dialog
      ref="climateDialog"
      v-show="showClimateDialog"
      :defaultLocation="growBaseText"
      :mapImg = "mapImgSrc"
      @close="showClimateDialog = false" />
  </div>
</template>
  
<script>
import HelloWorld from '@/components/HelloWorld.vue'
import ProcessFlowViewer from '@/components/ProcessFlowViewer.vue';
import QualityDetailsViewer from '@/components/QualityDetailsViewer.vue';
import ClimateDialog from '@/components/ClimateDialog.vue'

import axios from 'axios';
import { Dialog } from 'vant';
import DOMPurify from "dompurify";
import { ImagePreview } from 'vant';


export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    ProcessFlowViewer,
    QualityDetailsViewer,
    ClimateDialog
  },
  data() {
    return {
      activeName: '-1',
      healthyDrink: '',
      traceCode: '',
      healthyDrinkMaterial: '',
      batchNo: '',
      productLevel: '',
      produceDate: '',
      packageDate: '',
      materialBatchNo: '',
      materialPlace: '',
      material: '',
      imgDrink: '',
      imgDrinkList: [],
      showDrinkList: false,
      indexOfDrinkImage: 0,
      imgQualityList: [],
      showQualityList: false,
      indexOfQualityImage: 0,
      showQualityDeviceList: false,
      showImageQualityDevice: false,
      indexOfQualityDeviceImage: 0,
      imgCertList: [require('../assets/cert_1.jpg'), require('../assets/cert_2.jpg')],
      imgCert: require('../assets/cert_1.jpg'),
      showCertList: false,
      indexOfCertImage: 0,
      imgLogo: require('../assets/logo.png'),
      productCode:'正在加载，请稍等......',
      inspectDate:'',
      productSpec:'',
      materialSpec:'',
      pesticideUse:'',
      growthCycle:'',
      harvestTime:'',
      harvestImgs:'',
      plantTime:'',
      processTime:'',
      primaryProcessingMethod:'',
      imgTechFlowList: [],
      showTechFlowList: false,
      indexOfTechFlowImage: 0,
      salesYear:'',
      salesInfo:'',
      currentYear: new Date().getFullYear(),
      isRotated: false,
      imgStyle: {},
      showClimateDialog: false,
      growBaseText:'',
      mapImgSrc:''
    };
  },
  mounted() {
    this.traceCode = this.getParameterByName('traceCode');
    localStorage.removeItem('GEODetails')
    console.log('traceCode', this.traceCode);
    axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/Trace/GetTraceData?traceCode=${this.traceCode}`).then(response => {
      if (response.data.status != 0) {
        Dialog.alert({
          message: response.data.text + ` ${this.traceCode}。现在跳转至官方网站`,
        }).then(() => {
          window.location.href = "https://www.hbrkyy.com";
        });
        return;
      }

      this.healthyDrink = response.data.data['HealthyDrink'];
      this.batchNo = response.data.data['BatchNo'];
      this.healthyDrinkMaterial = response.data.data['HealthyDrinkMaterial'];
      this.inspectDate = response.data.data['InspectDate'];
      this.packageDate = response.data.data['PackageDate'];
      this.productLevel = response.data.data['ProductLevel']
      this.materialBatchNo = response.data.data['MaterialBatchNo'];
      this.materialPlace = response.data.data['MaterialPlace'];
      this.material = response.data.data['Material'];
      this.productCode = response.data.data['ProductCode'];
      this.materialSpec = response.data.data['MaterialSpec'];
      this.productSpec = response.data.data['ProductSpec'];
      this.primaryProcessingMethod = response.data.data['FirstProcessMethod'];
      this.pesticideUse = response.data.data['PesticideUse'];
      this.growthCycle = response.data.data['GrowthCycle'];
       

      this.harvestTime = response.data.data['HarvestTime'];
      this.plantTime = response.data.data['PlantTime'];
      this.processTime = response.data.data['ProcessTime'];

      this.salesYear = response.data.data['SalesYear'];
      this.salesInfo = response.data.data['SalesInfo'];

      this.growBaseText = response.data.data['GrowBaseText'];
      
      if(response.data.data["ProductImage"] != null)
      {
        var pImgs = response.data.data["ProductImage"].split(",");
        pImgs.forEach((element, index, arr) => {
          arr[index] = "data:image/jpg;base64," + element ;
        });
        this.imgDrinkList = pImgs;
      }

    if(response.data.data["TechFlowImage"] != null && response.data.data["TechFlowImage"] != '')
        this.imgTechFlowList = ["data:image/png;base64," + response.data.data["TechFlowImage"]];

      this.imgQualityList = ["data:image/jpg;base64," + response.data.data["MaterialInspectReport"], "data:image/jpg;base64," + response.data.data["ProductInspectReport"]];
      
      if(response.data.data["OthersImages"] != null)
      {
        var oImgs = response.data.data["OthersImages"].split(",");
        oImgs.forEach((element, index, arr) => {
          if(element != '')
            this.imgQualityList.push("data:image/jpg;base64," + element) ;
        });
      }
      
      this.loadGEOData();

    }).catch(error => {
      console.log(error);
      Dialog.alert({
          message: '抱歉，出错了，稍后再试，现在跳转至官方网站',
        }).then(() => {
          window.location.href = "https://www.hbrkyy.com";
        });
        return;
    });

  },
  methods: {
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    onChangeImageDrink(index) {
      this.indexOfDrinkImage = index;
    },
    onChangeImageQuality(index) {
      this.indexOfQualityImage = index;
    },
    onChangeImageQualityDevice(index) {
      this.indexOfQualityDeviceImage = index;
    },
    onChangeImageCert(index) {
      this.indexOfCertImage = index;
    },
    onChangeImageTechFlow(index) {
      this.indexOfTechFlowImage = index;
    },
    showImageDrink(){
      this.showDrinkList = true;
    },
    showImageQuality() {
      this.showQualityList = true;
    },
    showImageCert() {
      this.showCertList = true;
    },
    showImageTechFlow() {
      this.showTechFlowList = true;
    },
    async openGoodsDetails(goodsNo)
    {
     // 拼接目标 URL
      const fullUrl = 'http://2dcode.org/010' + goodsNo;

      // 复制到剪贴板
      try {
        await navigator.clipboard.writeText(goodsNo);
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = goodsNo;
        textarea.style.cssText = 'position:fixed;opacity:0;';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

      window.open(fullUrl, '_blank'); 
    },
    async previewImg(images, index){
      ImagePreview({
        images,      // 图片数组
        startPosition: index,  // 从哪张开始预览
        closeable: true,  // 显示关闭图标，用户手动点击关闭
      });
    },
    onImageLoad(e) {
      const img = e.target
      const isPortrait = img.naturalHeight > img.naturalWidth;
      
      if (isPortrait) {
        // 竖图：旋转90°使长边水平
        img.style.transform = 'rotate(90deg)';
        
        // 关键：旋转后宽高互换，让长边（原高度）匹配容器宽度
        img.style.width = '10rem';   /* 原高度 → 现在作为宽度 */
        img.style.height = 'auto';
        img.style.maxWidth = 'none';
        img.style.maxHeight = 'none';
      }
      // 横图：保持默认，不做处理
    },
    handleContainerClick(e) {
        const cells = this.$refs.supplierContent.querySelectorAll('.van-cell')
        let currentTargetCell = e.target
        cells.forEach(element => {

          if (!element) return
          
          const titleEl = element.querySelector('.van-cell__title')
          if (!titleEl) return
          
          const titleText = titleEl.textContent.trim()
          if(titleText != '基地') return;
          
          const valueEl = element.querySelector('.van-cell__value')
          if (!valueEl) return
          
          const imgEl = valueEl.querySelector('img')
          if (!imgEl) return 

          if(currentTargetCell == imgEl)
          {
            this.mapImgSrc = imgEl.src;
            this.showClimateDialog = true;    
            this.$nextTick(() => {
              
              this.$refs.climateDialog.showDialog();    
            })
          }

        });

        if(e.target.src != undefined && this.showClimateDialog == false)
          this.previewImg([e.target.src], 0);

    },

     async loadGEOData() {
      try
      {
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/Trace/GetGEODetails`, {'target':this.growBaseText});
        if (response.data && response.data.status == 0) {
            localStorage.setItem('GEODetails', JSON.stringify(response.data.data))
        }
      }
      catch(err)
      {

      }
    }
  }
}
</script>

<style>

.img-box {
  height: 10rem;          /* 固定高度（正方形容器） */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.auto-landscape {
  /* 默认状态：横图直接 fit */
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.2s ease;
}


span {
  white-space: pre-line; /* Ensures '\n' is rendered as a line break */
}

body::-webkit-scrollbar {
    width: 0;
}

.home {
    padding-left:0.6rem;
    padding-right:0.6rem;
}




.sy-accordion {
  width: 100%;
  padding: 0.1rem 0 0.1rem 0;
}

.sy-accordion-head {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAq4AAABYCAYAAAA0q3UrAAAa7klEQVR4Xu2dTYgkWbXHT1RlVld128MTGwTFhXZL916YxYgguHgNLtTlPHQWas+6FzKCCxcuBIcH9lLUmcUozlJdiO8tBEFmFgPulenWhSgqPfRHVeVHZHzIicjIvBl5PyJOfEf+A5qxuzIi7v3diPRX5557rkdEUyLylD+0+/cbR7f+51svHZ/+1106Pn7R845vUkwfJo9O+IM4QAAEQAAEihGYHHv0oTP9Vyd/CesOzzP9JP3ith3Wc10nay58Mjmis5PJ/k+EbbScRp6jd7ZznWCKDVejn/JXIZ3PV43eo8mLz5YrulwETd4C1x47gZh88uhJHIePKAzfCxdP/+/hL/73XaLHERHFyh8msfk7f3Xxt6gqrpv/feuVB1+enF7/LpH36bHzQ/9AAARAoEkCLFrXz07o6MhujBKB5XbbrlqHwB55Hn3odEpWYUwaom+JvX0OAbf0bogCG0UxPb1cUsz/VzzAIwgjenKxHGDL0eT+E4jfDxbn33v41v1f5eR1R1yv5MX1E1/8zievfuxTb3je0Yv97yRaCAIgAAL9J3DtyoSmk+Pdhlpsrm2BtThn0uZrp1M6VqTbGbAVCKyrDbYorFuo+/OMPL/0aRVyUGl4RxzHibSG0UCte3jID7LFcRy9N/vHX77xt998/695geXvnlNVXG++/Prnptdv/JyIPnKQtNBpEAABEKiZAE+xX73CWVmGQyCwqeTVn0agu+Tp9JhOpjnpVrpilVhhG6VpBH0X2PkyoNlyuFPsF3Of5n5Y8xuCy4GAlsAHq/PHX3309mt/yKcKsLge8XfgWlp/vU4fAEcQAAEQAIGKBPJT7DbZdOVmSqKw0hSCLPrJUVZVuu1C6YAliMJKBdYVvXWxrjjs2tPDMKKnl34Tl27lmn4Q0rMBt78VSLhJ3QT81fnjLynyGvF32hmLK6cHXPv4rd8j0lo3c1wPBEDgkAlwXqg6xZ6xaEJgbVFY19S+rj0sjdeuTLV5uWKBbSACm/S753mwnM/67HK4U+ycl/vkYkHIEDjkb7PO+v7B5d8ffn6dNpCI61UW19v3fvo75LR2Nii4MQiAwAgJZFPsVaKetsig5LplBPbs5Jgmx8mEXDI6Oud0Tc0b7ycUWFckVSywqf02dswWAc394aYIcF7uMkCKQGMPCC5sJcA5r3/+yTe/QESJuF679cqDr0xOX/gZuIEACIAACNRDgKOsvKBJPVxeJI3CSlIIXJ52Mjmm05N8XqtMYF39tpUqkFYj6JPABkFEz2bDTRFY+MGgS3fV80bjKl0TCBbPv/bwrfu/9IhuXL/z6g/+iJJXXQ8J7g8CIDAWAklE4GxKnN+qO1wiV7fAplHK4gu5uHgA57Vmp+yfaxZYd0TUMsol2rjzC4F1cZudtvGWrkEq+LDyKvynFz5FA619FUYRPTlfJkU0cYBAtwTi9//0429/hhdk3Z1ev/HbbhuDu4MACIDAeAhwkf50ij09pPmgUoFN7mnAWURgr55MNnmtatv15zYQhW1AYFMmFnm3hnblz+bFfEXL1XCn2J9eLAdbuks+ajizrwSCi3/f9W5//Uc/9CYn9/vaSLQLBEAABIZEYDo5otOpZnepDgRWkgN7ZXJM3AfdueYI7FaVa82DtVi/NIWgTYEd/O5YixVdDrh015C+N9DWYgTiwH/g3b73xjue571U7BR8CgRAAARAwESAp9jP1lPspuieeDHTJnprnRc3Dk4RieW83NP1lq7Z59sSWOvMfAcRWFek3LWQC7tj4XsCBOonEMfxu96dV9/8JxF9tP7L44ogAAIgcFgErl7ZTrGrPZdIrCvFUppGYEsh4Pbnr1tVYHUCWEneG5DYJlIIsDvWYb376G1rBP7l3bn35pI8OmntlrgRCIAACIyQAK/CT6bYBQuFqohcXQJ7ZZqVvtIv5CoisKmk5gFs/142jaDtKKxNYMtEYLE71ghfcHSpHwRi8jniisWC/RgOtAIEQGCgBNQp9qwLQxFYbu/02CMW723bswVX5qoIthQCvcAm/5rcIs+mirhrL7juiDQPtorA8ip87I410BcZzR4EAYjrIIYJjQQBEOgrAZajM80UuzNCV2GVe5F8VSOv3MksjVwFYauVu2dyBNUU1S0ShW2tEoEFuDvtwvx0lUkjSHbHmmF3rL6+q2jXOAhAXMcxjugFCIBARwR4ip0jrtYpe0dFgVQaDdFN2VosZ3uy2/EmA/l6s/poqjkKyz8x586mA2MT2NqjsOL6udUEllfgc7H+oR7YHWuoI3dY7Ya4HtZ4o7cgAAI1EpjkptizS1trpQpyYItFby3SZRA5zsnlP6ZDIrDmyK1bYMvmwJrutelPiwK7CiN6PvOtOc41Pnq1Xwq7Y9WOFBdsiADEtSGwuCwIgMC4CahT7EbxcyRv1p0H654S337i6Mgjrtm6aUPJyG4m5zpJL5JC4IrClpXYLhdy8a5Yzy6XFK1XjLhydvv2ZmB3rL6NCNpjIwBxxfMBAiAAAgICuin2vgisKxLJsnk6ZWnVrPh32O9ezYD1NWwC22YU1iXvppCodCEX9+1ywbtjRdrhH4LEYncswRcATumMAMS1M/S4MQiAwFAJJFPsypauRftRJQ+2zCIhtT06ITuZHNHxEZfu2v/pzj8JorC2hVx1ViJII7Z28pIorEt88/dUd8eSpogUfX6a+NwMu2M1gRXXbJAAxLVBuLg0CIDA+AjwQiZekFVEnGy9l0pOVYHlhWRZXmt2LaNs2ub8150z5cG2WYnANRYSgXVHrYlMu2NJx7bttyUII3pysWz7trgfCFQiAHGthA8ngwAIHBIBFiCW1r3dpVxhOgskqeRIBJa3pOV6rXt1VJWaANYorCACm0qlJrJrFd8tsD5vaMCLsVj+JL+guKLFTb9XcRwn0hpmiblN3xDXB4GaCEBcawKJy4AACIyfAE+x86ImiTS66DSRRpCXI25/WpdVX75K7ZdUYHWRyiILufTn2QR2e0atC7lS09YOl/qvcz+g2XJb+sqeI2v/zaYLib2Y+zT3Q9djiZ+DQO8IQFx7NyRoEAiAQB8JqFPsWfuGIrDc3unES/Ja1SMTJu10/2aXK0sebMkcU5vAquK6vwCsA4G12GTk2B1LKrFtCawfhPTs0u/ja4Y2gYCTAMTViQgfAAEQOHQCLBS6KfYdCRRsIGDjWmcElvNyN3mtGquqLLC6cKnSOUkerEn+Nm3VWl56VqMR2Jjo6eUimWJ3jpFlgKUpIlXfRc7LfXKx2JTuqno9nA8CbROAuLZNHPcDARAYHIFsit0kRUUEtsi5JjBSyckiwmr7s3uYonuuNIK2KxGYnLgJgXX4d2LEvAqf0wTyh3WMhAJb5Zkx3RK7Yw3u6wcNzhGAuOKRAAEQAAELgckxl44y5DxaFyuVP8c1EM4In+aWXLbLlpcrFdhUqtpJI1DvUi6NYPvpOqKwvDvWM94dSyii4vMqLP5Tm8rCfTFfuR4z/BwEek0A4trr4UHjQAAEuiTAU+wsrq7Ily03sYk8WJM05qOpaft5MZYicBbtssldE3mwphQCW/+yc/TnpgSaqETAu2M9vfSJ/7vh3LLAup5D27uC3bG6/CbBveskAHGtkyauBQIgMCoCHK0sU/qqbYF1pRBwikD+2CyQ6pHAJkKmeXLSCgjmFf42eTXLrywPliOVy8C8Ct+ck+uoKCCV35JRWC595SrdNaqXF50ZLQGI62iHFh0DARCoQoAjrRyxNB2uFeDGKfiSwli0D3nBmyqRVn0kdS1wJduTnFWlnJZDuMpGYU0RWLXPevktLrDLVbg7xW5NETGPmGtTBvOz5pBfB1PsjlX0LcLnhkAA4jqEUUIbQQAEWiXAKa3Hypau0ul+p9zWXIkgizJyTq4q3duFTPsYi6QRSPNgm9iRyxRJLZJCoD/XngfLhfqfXi5JyRDYQqxZYE2R5+yGrgi77iXB7litfnXgZi0QgLi2ABm3AAEQGA4BdpGJZoo9lYr6I7C267rEV0eVz+Fosa6tbQus2jdrykXJKGyRDQ3K5cDuKqPK/flsSasgspe+Egisc6Gd45UpIrHYHWs43ztoaXECENfirPBJEACBAyAw4Z2xTDWh1v23CWwa1TODajoPltvPDdjWZt1vTJMCq4sadrEjl9qOPAF7GsH204tVkJS/Ug+rcJYU8EKR1AoCe7HwaYHdsQ7gW+uwughxPazxRm9BAAQsBPJT7MlHrdE0ee6hK5pqkmPbedx+W2RTGoUt25atNO/Dzq7V93qwQRgTR1tNh1RgbU9MlShs/lzeHev5DLtj4QtvfAQgruMbU/QIBEBAQIBlKxE/u6maRabjNAIOtCZ5raZV+GtjssmrKVoszYMtIrDpPXd1buevJafhJWkE+QgsT7FzvVbeHcvxu4s4haDKdV3yyyW7eHcsbV6u4N3AKSDQJwIQ1z6NBtoCAiDQGYE0Wrm9/VAENpPNJEVAPRwCm4pTu2kE2rxTpQ1SgdVJoERgM5azZUCL1X7pK0cmgFhiTdeVRmDP5z75QdTZu4Qbg0CTBCCuTdLFtUEABAZBgAsImEsVlQz5rXvc5kKuTFq1rlqgpFeVKKwkjcAoamuJbWtHrkx41fbw7ljn85U1T7lKtFQY0LdLsZLRwsJ9mcvLHcRLiEaCQEECENeCoPAxEACBcRJgr8tKR0nzTrvIg82EMV2LlarXpiSUOYSnHUTbQq4sCqn+dzewm927XMWFImkEbQnspuXrFIF1hsCmm/YFdeb3ou082CiK6RmX7hrnq4pegUD6PXfn1TfxjONhAAEQOFgCnCKQP8QC6wjFSaOwxjqqRHSkycutKrBpN8x5p7r2iHfkWjOzpRG0tZDrcr4ijriajkYE1vnMFBNjzss9n/kU5K37YN9sdHysBCCuYx1Z9AsEQMBJIHXW3dzW3Wii/RJGEXWWRSoXnTS1iSPF1rJXyol70uWw86rltCSSnqwt0yC3ldPadMPJfP/Cah6sz1Psy23pK0n7HQ7qnO6XpBFkfZgvA5r7gfOZxwdAYOgEIK5DH0G0HwRAQESAPce6GCh3VXu0rf08WDVFIGuqS2KNfWggD7btSgSJNG5CzZYopeZHPO3I0Urd9OMQBJZ3x+K8XBwgcAgEIK6HMMroIwiAwB4BdUvU/A+tkmp11PYE1paX6xLYHckr2HlpBDa9lz0P1pgKscaZp1r3hgYXixVx3VYrF8vOae7UEotIC/MPMiacIvB8tiIugYUDBA6BAMT1EEYZfQQBENghULTslVRgEwEyzfs6p7TdaQQ6idTnnabd1lYNWBMpG4UtIrA6ASwSgTWJo2khV2GBTSFoD04RmGt2l5JG2IUeKi6lNV+uaLlC6St8xR0OAYjr4Yw1egoCIGCRtS62cZVUI0jyQDUStt2Ran+YxRFYYR7szi8GurY6IrBGgV0LqHghV+7EMIyJo622o1cCmxPwVRCh9BW+1Q6OAMT14IYcHQYBEJDKiEmoMqLi65ZMP9iIqFBgdVHYJioRqLz0EWFhKa2qAktEMcV0MV9tdsdK2+qOdpvenrL1bC1B4M0tbO2JKK0igAwBfJ8dGgGI66GNOPoLAiCgiIEZxhAisEUEVifbrlSJdOGagU0BuRvCjly8An+p2R1rKALLmwzYSnfhNQeBsRKAuI51ZNEvEACBwgTci2tkkbi2I7CmiHCRNIImorC2KKQtAqtrizqY9nze/WHf9j8dR16Fr5a+MkZRC6ZK6M6XVCNwpD9vIsIs3Ch9Vfj1xgdHRgDiOrIBRXdAAASqEZDKplN+S6YDJL0oeY4zt3SzpapG7jYr+Pdv2kQagbOt0jxYQyWCTIZ57f3FotwUu3UHLFt0uoFKBFw9AKWvqr3jOHvYBCCuwx4/tB4EQKAhAr0S2JIS65TCAxZYriDAEVfpIc2DlURgdcPOi8lC7I4lHT6cNwICENcRDCK6AAIg0BwBqcAm0mGLmJaMpm56WPI8m8S2nUKgMpHmwUoEMGPAwjpfhluUrrl5y2PVhcAuVqExL7e5NwBXBoF+EYC49ms80BoQAIGeEnCmAljm9dsW2DRSt2tl0oVcTtlcj5e2jx0t5NL90sCF+meLQL87VgcCqxuj7NHXYQsjLn2FLV17+vWAZrVIAOLaImzcCgRAYPgEuojA2iSnizxYrRhXFFibbJui12V25Jott1PskqhtkSfXFIWV/tKTncfSzVUEkCFQZBTwmbETgLiOfYTRPxAAgUYISGXEJGFqI0VyXDKFYCeSKqwH28SOXCZJt0aMFWC6Nq2CkJbBNkVgh7XB/F3ja3qomljItVgFxJsN4AABECCCuOIpAAEQAIGKBESiaYtQFvlZjVvKFkkjMPVxc24+NcHVh5bSCKIo3pS+MvZBmOZhe2zqEtgkL9dHikDFVxSnj4gAxHVEg4mugAAIdEvAFaWTTlGLxbhkFLaIwOoixjsLwDQSaC2n1bDAcl4rl5AqEtGWjo/rqZMu5OJmzxYrbV6u6574OQiMlQDEdawji36BAAh0RmBIApuIaImFXOrndf00RWDT89JDupCrbFv9VWTcXaqpMZJGYXXtWfgBBeGudHf2UOPGINATAhDXngwEmgECIDA+AuJIaYVSWjq525B1rJ43CaxJNhsppyWMwKpt5EuEYUxcs9UoysrjJh0nl/yanugiEVjOaTVtSTu+NwU9AoHiBCCuxVnhkyAAAiAgIuASHOkUdZXrmlNk9XZbJI3AFoHVRkvXNI39MPzAGtX1iHgVPktrLkPAKbFSnq7zykZhObVhvkReq+hlw0mjJwBxHf0Qo4MgAAJ9IuCSnCYk1nZNaTktraQqF8v/vEgKgTE66hDYvBQvVwEFUbyXAqE+B9Yoa8nIdHZd19gWFViW1nxebp+eYbQFBLokAHHtkj7uDQIgcLAEXJIzFIHVyaY0hSAV0PSQ5sHydqj5KfYmWOoiyHUILFcR8FH66mC/F9BxNwGIq5sRPgECIAACjRGQ5lca5c4mftnP7GFWa197sZDL0PmYYlqs81p1nbBGnivkFUvFON9GLt3F27riAAEQMBOAuOLpAAEQAIGeEJBKbBPT3ja3NUUbTXmwqtjVWokgJ7BLP9xOsZcsBaY+AlKeJoF1Rdf53pyPyxsN6PJye/J4ohkg0AsCENdeDAMaAQIgAAJbAlKBbTsK6xI1Wx5s3Qu5VmFMPM2uPYQSKxVYk9jbxsdfhUleLg4QAAE7AYgrnhAQAAEQ6CkBqcC6Inyi65ZcsGRanJWhlkZhdTmwvJApm2KvcyHapq028S3JRXfNMOLSV9jStaevIZrVMwIQ154NCJoDAiAAAnkCThEVblkqEtg0nGg8dOJoSiHIRyalaQTJFHuuRUaBFYpmVYk1C3Wal4tYK957EChGAOJajBM+BQIgAAKdExiSwOalNPm7Io3SNIK8AK6CkEJHYqhEYqssuCrzCwFXQEDpq85fLTRgQAQgrgMaLDQVBEAABApF/oQR2Lxc7kV+zbsWWAdGGoV1RWB5il0tHVVGGHcaXDKCXGQMXCz551y6i3fIwgECIFCcAMS1OCt8EgRAAAR6R0Asa02Ufyo5DV80AmuSQF7QpJtirxKZLpsGUURide3h3b2Q19q71wkNGgABiOsABglNBAEQAAEXgV4JbGKa5haXjcCml0svmPWTI5UcsXRFNsVcSra/rMByigBKX7meavwcBPYJQFzxVIAACIDAiAiIRa2JCGwFgTUJKQssC6uu9JW0fFXblQg4xSEIsRxrRK8dutIiAYhri7BxKxAAARBoi0CV6XKpAKqR0b1+lkwjUMVVbQ9HKV15odL2NyGweQHnhViu9rf1jOA+IDBEAhDXIY4a2gwCIAACJQhIo7BO+ZVMp1cUWD/YnWKXrv539k2wEM21pSwPGVdBQKy1xMOLj4JAjgDEFY8ECIAACBwIAanA5qOGeVyi6woENoq3ea17bRBWUmhCYE2RZ05vQOmrA3nZ0M3GCHh37r25JI9OGrsDLgwCIAACINArAiLRXPdAOg1vkrnksgUit7wKf7Xe0rWL9ldNI2BhNW5J26unA40BgR4TiMnniOs/ieijPW4mmgYCIAACINAAAXG0sYOFXEEQ7e+OJYjaZhilAi4SWM7LXUt3A8OIS4LAIRH4l3f73hvveJ730iH1Gn0FARAAARDYJSCNYkoFsEwENkym2M0j1oWAl2k/R1pR+gpvHAhUJxDH4bve7a//6Ife5OR+9cvhCiAAAiAAAkMn0DeB5RSBMqWjmmh/IqkF0hl0Y88pAlm92aE/G2g/CHRNIA78B97Nl1+/O71+47ddNwb3BwEQAAEQ6A8BaRTTeV4JAYypnLSq9KSiWWv7WbptoeL+DDdaAgKDIBBc/PuuR3Tj+p1Xf/BHIu/Tg2g1GgkCIAACINAaAakAOqOUBQQ2iKpPsTtFtIFqBFkebJIi0NpI4UYgMHYC8ft/+vG3P8NfHdduvfLgK5PTF3429i6jfyAAAiAAAjICTQmgSXB5ij2KZG3VndVU+03X5baj9FV944crgUCweP61h2/d/yWL61UiOrp976e/87yjF4EGBEAABEAABGwEpFFYpzyuo7C8kKmpvFBnG4QRWFXAOS8XRQTwDoFAfQTiOHrvzz/55heIKOKviTMW10988TufvPbxW78noo/UdytcCQRAAARAYKwEpAJrirJm/x6GnN3a/CFtv6uSQpnFZM33EncAgcET+ODy7w8//7fffP+vmbiesrjyosmbL7/+uen1G78mwoYEgx9mdAAEQAAEWiIgFUCdwPL0etulo6Tt150XRe1Id0tDi9uAQNcE/NX54y89evu1PxAlv88mEVcWV/5v8mctrz9H5LXrscL9QQAEQGBYBKpOw/MUe5eL8Ife/mE9LWgtCDgJfLA6f/xVRVpZXGOW1SuquPL/5rSBqx/71BvIeXVCxQdAAARAAARyBKQC2KfFTOWjsN1KNx5CEBgTAc5pnf3jL99Ypwckwpr9YXE9yYtr9vdbrzz48uT0+ndRKmtMjwP6AgIgAALtESgqgH2SVpXO0Nvf3kjjTiBQB4H4/WBx/r2Hb93/lSqreXGd5sSV77xJHSC6cXTz5dc+Ozl74b/pePqi53k3KaYPk4c82DqGCNcAARAAgUMgYI3Cxmk4pc/H0NvfZ7Zo24ESiMknj57EcfyIwtV7wfz5/z96+/V3iB5zITw1ysqANn//D4dDwb5KfI/aAAAAAElFTkSuQmCC);
  /* background-color: #3D8BFF; */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  padding: 0 0.14rem;
  overflow: hidden;
  height: 0.44rem;
  border-radius: 0.07rem;
  -webkit-box-shadow: 0 0 0.09rem 0.03rem RGBA(0, 0, 0, 0.12);
  box-shadow: 0 0 0.09rem 0.03rem RGBA(0, 0, 0, 0.12);
}

.sy-accordion-head .sy-accordion-head-arrow {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.sy-accordion-head .sy-accordion-head-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}



.van-cell-group__title {
  padding: 16px 16px 8px;
  color: #969799;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
}

[align='left'] .van-cell__title {
  width: 70px;
  flex: none;
  color: #88898a;
}

[align='left'] .van-cell__value {
  text-align: left;
  color: #555657;
}



.van-cell__title,
.van-cell__value {
  text-align: left;
}

.van-cell__value {
  text-align: left;
  padding-left: 7px;
}

.sy-row {
  min-height: 0.36rem;
  border-top: 0.01rem solid #E9EAEE;
  border-left: 0.01rem solid #E9EAEE;
  border-right: 0.01rem solid #E9EAEE;
  width: 100%;
  display: table;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.sy-row-div {
  padding: 0 0.1rem 0.1rem;
}

.sy-row .sy-row-name {
  display: table-cell;
  width: 0.9rem;
  font-size: 0.14rem;
  color: #666;
  height: 0.3rem;
  font-weight: bold;
  text-align: center;
  background: #f4f9fd;
  vertical-align: middle;
}

.sy-row .sy-row-val {
  display: table-cell;
  border-left: 0.01rem solid #E9EAEE;
  font-size: 0.14rem;
  color: #666;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  vertical-align: middle;
  padding: 0.07rem 0 0.07rem 0.13rem;
}

.sy-accordion {
  width: 100%;
  padding: 0.1rem 0 0.1rem 0;
}

.sy-accordion .sy-accordion-head {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAq4AAABYCAYAAAA0q3UrAAAa7klEQVR4Xu2dTYgkWbXHT1RlVld128MTGwTFhXZL916YxYgguHgNLtTlPHQWas+6FzKCCxcuBIcH9lLUmcUozlJdiO8tBEFmFgPulenWhSgqPfRHVeVHZHzIicjIvBl5PyJOfEf+A5qxuzIi7v3diPRX5557rkdEUyLylD+0+/cbR7f+51svHZ/+1106Pn7R845vUkwfJo9O+IM4QAAEQAAEihGYHHv0oTP9Vyd/CesOzzP9JP3ith3Wc10nay58Mjmis5PJ/k+EbbScRp6jd7ZznWCKDVejn/JXIZ3PV43eo8mLz5YrulwETd4C1x47gZh88uhJHIePKAzfCxdP/+/hL/73XaLHERHFyh8msfk7f3Xxt6gqrpv/feuVB1+enF7/LpH36bHzQ/9AAARAoEkCLFrXz07o6MhujBKB5XbbrlqHwB55Hn3odEpWYUwaom+JvX0OAbf0bogCG0UxPb1cUsz/VzzAIwgjenKxHGDL0eT+E4jfDxbn33v41v1f5eR1R1yv5MX1E1/8zievfuxTb3je0Yv97yRaCAIgAAL9J3DtyoSmk+Pdhlpsrm2BtThn0uZrp1M6VqTbGbAVCKyrDbYorFuo+/OMPL/0aRVyUGl4RxzHibSG0UCte3jID7LFcRy9N/vHX77xt998/695geXvnlNVXG++/Prnptdv/JyIPnKQtNBpEAABEKiZAE+xX73CWVmGQyCwqeTVn0agu+Tp9JhOpjnpVrpilVhhG6VpBH0X2PkyoNlyuFPsF3Of5n5Y8xuCy4GAlsAHq/PHX3309mt/yKcKsLge8XfgWlp/vU4fAEcQAAEQAIGKBPJT7DbZdOVmSqKw0hSCLPrJUVZVuu1C6YAliMJKBdYVvXWxrjjs2tPDMKKnl34Tl27lmn4Q0rMBt78VSLhJ3QT81fnjLynyGvF32hmLK6cHXPv4rd8j0lo3c1wPBEDgkAlwXqg6xZ6xaEJgbVFY19S+rj0sjdeuTLV5uWKBbSACm/S753mwnM/67HK4U+ycl/vkYkHIEDjkb7PO+v7B5d8ffn6dNpCI61UW19v3fvo75LR2Nii4MQiAwAgJZFPsVaKetsig5LplBPbs5Jgmx8mEXDI6Oud0Tc0b7ycUWFckVSywqf02dswWAc394aYIcF7uMkCKQGMPCC5sJcA5r3/+yTe/QESJuF679cqDr0xOX/gZuIEACIAACNRDgKOsvKBJPVxeJI3CSlIIXJ52Mjmm05N8XqtMYF39tpUqkFYj6JPABkFEz2bDTRFY+MGgS3fV80bjKl0TCBbPv/bwrfu/9IhuXL/z6g/+iJJXXQ8J7g8CIDAWAklE4GxKnN+qO1wiV7fAplHK4gu5uHgA57Vmp+yfaxZYd0TUMsol2rjzC4F1cZudtvGWrkEq+LDyKvynFz5FA619FUYRPTlfJkU0cYBAtwTi9//0429/hhdk3Z1ev/HbbhuDu4MACIDAeAhwkf50ij09pPmgUoFN7mnAWURgr55MNnmtatv15zYQhW1AYFMmFnm3hnblz+bFfEXL1XCn2J9eLAdbuks+ajizrwSCi3/f9W5//Uc/9CYn9/vaSLQLBEAABIZEYDo5otOpZnepDgRWkgN7ZXJM3AfdueYI7FaVa82DtVi/NIWgTYEd/O5YixVdDrh015C+N9DWYgTiwH/g3b73xjue571U7BR8CgRAAARAwESAp9jP1lPspuieeDHTJnprnRc3Dk4RieW83NP1lq7Z59sSWOvMfAcRWFek3LWQC7tj4XsCBOonEMfxu96dV9/8JxF9tP7L44ogAAIgcFgErl7ZTrGrPZdIrCvFUppGYEsh4Pbnr1tVYHUCWEneG5DYJlIIsDvWYb376G1rBP7l3bn35pI8OmntlrgRCIAACIyQAK/CT6bYBQuFqohcXQJ7ZZqVvtIv5CoisKmk5gFs/142jaDtKKxNYMtEYLE71ghfcHSpHwRi8jniisWC/RgOtAIEQGCgBNQp9qwLQxFYbu/02CMW723bswVX5qoIthQCvcAm/5rcIs+mirhrL7juiDQPtorA8ip87I410BcZzR4EAYjrIIYJjQQBEOgrAZajM80UuzNCV2GVe5F8VSOv3MksjVwFYauVu2dyBNUU1S0ShW2tEoEFuDvtwvx0lUkjSHbHmmF3rL6+q2jXOAhAXMcxjugFCIBARwR4ip0jrtYpe0dFgVQaDdFN2VosZ3uy2/EmA/l6s/poqjkKyz8x586mA2MT2NqjsOL6udUEllfgc7H+oR7YHWuoI3dY7Ya4HtZ4o7cgAAI1EpjkptizS1trpQpyYItFby3SZRA5zsnlP6ZDIrDmyK1bYMvmwJrutelPiwK7CiN6PvOtOc41Pnq1Xwq7Y9WOFBdsiADEtSGwuCwIgMC4CahT7EbxcyRv1p0H654S337i6Mgjrtm6aUPJyG4m5zpJL5JC4IrClpXYLhdy8a5Yzy6XFK1XjLhydvv2ZmB3rL6NCNpjIwBxxfMBAiAAAgICuin2vgisKxLJsnk6ZWnVrPh32O9ezYD1NWwC22YU1iXvppCodCEX9+1ywbtjRdrhH4LEYncswRcATumMAMS1M/S4MQiAwFAJJFPsypauRftRJQ+2zCIhtT06ITuZHNHxEZfu2v/pzj8JorC2hVx1ViJII7Z28pIorEt88/dUd8eSpogUfX6a+NwMu2M1gRXXbJAAxLVBuLg0CIDA+AjwQiZekFVEnGy9l0pOVYHlhWRZXmt2LaNs2ub8150z5cG2WYnANRYSgXVHrYlMu2NJx7bttyUII3pysWz7trgfCFQiAHGthA8ngwAIHBIBFiCW1r3dpVxhOgskqeRIBJa3pOV6rXt1VJWaANYorCACm0qlJrJrFd8tsD5vaMCLsVj+JL+guKLFTb9XcRwn0hpmiblN3xDXB4GaCEBcawKJy4AACIyfAE+x86ImiTS66DSRRpCXI25/WpdVX75K7ZdUYHWRyiILufTn2QR2e0atC7lS09YOl/qvcz+g2XJb+sqeI2v/zaYLib2Y+zT3Q9djiZ+DQO8IQFx7NyRoEAiAQB8JqFPsWfuGIrDc3unES/Ja1SMTJu10/2aXK0sebMkcU5vAquK6vwCsA4G12GTk2B1LKrFtCawfhPTs0u/ja4Y2gYCTAMTViQgfAAEQOHQCLBS6KfYdCRRsIGDjWmcElvNyN3mtGquqLLC6cKnSOUkerEn+Nm3VWl56VqMR2Jjo6eUimWJ3jpFlgKUpIlXfRc7LfXKx2JTuqno9nA8CbROAuLZNHPcDARAYHIFsit0kRUUEtsi5JjBSyckiwmr7s3uYonuuNIK2KxGYnLgJgXX4d2LEvAqf0wTyh3WMhAJb5Zkx3RK7Yw3u6wcNzhGAuOKRAAEQAAELgckxl44y5DxaFyuVP8c1EM4In+aWXLbLlpcrFdhUqtpJI1DvUi6NYPvpOqKwvDvWM94dSyii4vMqLP5Tm8rCfTFfuR4z/BwEek0A4trr4UHjQAAEuiTAU+wsrq7Ily03sYk8WJM05qOpaft5MZYicBbtssldE3mwphQCW/+yc/TnpgSaqETAu2M9vfSJ/7vh3LLAup5D27uC3bG6/CbBveskAHGtkyauBQIgMCoCHK0sU/qqbYF1pRBwikD+2CyQ6pHAJkKmeXLSCgjmFf42eTXLrywPliOVy8C8Ct+ck+uoKCCV35JRWC595SrdNaqXF50ZLQGI62iHFh0DARCoQoAjrRyxNB2uFeDGKfiSwli0D3nBmyqRVn0kdS1wJduTnFWlnJZDuMpGYU0RWLXPevktLrDLVbg7xW5NETGPmGtTBvOz5pBfB1PsjlX0LcLnhkAA4jqEUUIbQQAEWiXAKa3Hypau0ul+p9zWXIkgizJyTq4q3duFTPsYi6QRSPNgm9iRyxRJLZJCoD/XngfLhfqfXi5JyRDYQqxZYE2R5+yGrgi77iXB7litfnXgZi0QgLi2ABm3AAEQGA4BdpGJZoo9lYr6I7C267rEV0eVz+Fosa6tbQus2jdrykXJKGyRDQ3K5cDuKqPK/flsSasgspe+Egisc6Gd45UpIrHYHWs43ztoaXECENfirPBJEACBAyAw4Z2xTDWh1v23CWwa1TODajoPltvPDdjWZt1vTJMCq4sadrEjl9qOPAF7GsH204tVkJS/Ug+rcJYU8EKR1AoCe7HwaYHdsQ7gW+uwughxPazxRm9BAAQsBPJT7MlHrdE0ee6hK5pqkmPbedx+W2RTGoUt25atNO/Dzq7V93qwQRgTR1tNh1RgbU9MlShs/lzeHev5DLtj4QtvfAQgruMbU/QIBEBAQIBlKxE/u6maRabjNAIOtCZ5raZV+GtjssmrKVoszYMtIrDpPXd1buevJafhJWkE+QgsT7FzvVbeHcvxu4s4haDKdV3yyyW7eHcsbV6u4N3AKSDQJwIQ1z6NBtoCAiDQGYE0Wrm9/VAENpPNJEVAPRwCm4pTu2kE2rxTpQ1SgdVJoERgM5azZUCL1X7pK0cmgFhiTdeVRmDP5z75QdTZu4Qbg0CTBCCuTdLFtUEABAZBgAsImEsVlQz5rXvc5kKuTFq1rlqgpFeVKKwkjcAoamuJbWtHrkx41fbw7ljn85U1T7lKtFQY0LdLsZLRwsJ9mcvLHcRLiEaCQEECENeCoPAxEACBcRJgr8tKR0nzTrvIg82EMV2LlarXpiSUOYSnHUTbQq4sCqn+dzewm927XMWFImkEbQnspuXrFIF1hsCmm/YFdeb3ou082CiK6RmX7hrnq4pegUD6PXfn1TfxjONhAAEQOFgCnCKQP8QC6wjFSaOwxjqqRHSkycutKrBpN8x5p7r2iHfkWjOzpRG0tZDrcr4ijriajkYE1vnMFBNjzss9n/kU5K37YN9sdHysBCCuYx1Z9AsEQMBJIHXW3dzW3Wii/RJGEXWWRSoXnTS1iSPF1rJXyol70uWw86rltCSSnqwt0yC3ldPadMPJfP/Cah6sz1Psy23pK0n7HQ7qnO6XpBFkfZgvA5r7gfOZxwdAYOgEIK5DH0G0HwRAQESAPce6GCh3VXu0rf08WDVFIGuqS2KNfWggD7btSgSJNG5CzZYopeZHPO3I0Urd9OMQBJZ3x+K8XBwgcAgEIK6HMMroIwiAwB4BdUvU/A+tkmp11PYE1paX6xLYHckr2HlpBDa9lz0P1pgKscaZp1r3hgYXixVx3VYrF8vOae7UEotIC/MPMiacIvB8tiIugYUDBA6BAMT1EEYZfQQBENghULTslVRgEwEyzfs6p7TdaQQ6idTnnabd1lYNWBMpG4UtIrA6ASwSgTWJo2khV2GBTSFoD04RmGt2l5JG2IUeKi6lNV+uaLlC6St8xR0OAYjr4Yw1egoCIGCRtS62cZVUI0jyQDUStt2Ran+YxRFYYR7szi8GurY6IrBGgV0LqHghV+7EMIyJo622o1cCmxPwVRCh9BW+1Q6OAMT14IYcHQYBEJDKiEmoMqLi65ZMP9iIqFBgdVHYJioRqLz0EWFhKa2qAktEMcV0MV9tdsdK2+qOdpvenrL1bC1B4M0tbO2JKK0igAwBfJ8dGgGI66GNOPoLAiCgiIEZxhAisEUEVifbrlSJdOGagU0BuRvCjly8An+p2R1rKALLmwzYSnfhNQeBsRKAuI51ZNEvEACBwgTci2tkkbi2I7CmiHCRNIImorC2KKQtAqtrizqY9nze/WHf9j8dR16Fr5a+MkZRC6ZK6M6XVCNwpD9vIsIs3Ch9Vfj1xgdHRgDiOrIBRXdAAASqEZDKplN+S6YDJL0oeY4zt3SzpapG7jYr+Pdv2kQagbOt0jxYQyWCTIZ57f3FotwUu3UHLFt0uoFKBFw9AKWvqr3jOHvYBCCuwx4/tB4EQKAhAr0S2JIS65TCAxZYriDAEVfpIc2DlURgdcPOi8lC7I4lHT6cNwICENcRDCK6AAIg0BwBqcAm0mGLmJaMpm56WPI8m8S2nUKgMpHmwUoEMGPAwjpfhluUrrl5y2PVhcAuVqExL7e5NwBXBoF+EYC49ms80BoQAIGeEnCmAljm9dsW2DRSt2tl0oVcTtlcj5e2jx0t5NL90sCF+meLQL87VgcCqxuj7NHXYQsjLn2FLV17+vWAZrVIAOLaImzcCgRAYPgEuojA2iSnizxYrRhXFFibbJui12V25Jott1PskqhtkSfXFIWV/tKTncfSzVUEkCFQZBTwmbETgLiOfYTRPxAAgUYISGXEJGFqI0VyXDKFYCeSKqwH28SOXCZJt0aMFWC6Nq2CkJbBNkVgh7XB/F3ja3qomljItVgFxJsN4AABECCCuOIpAAEQAIGKBESiaYtQFvlZjVvKFkkjMPVxc24+NcHVh5bSCKIo3pS+MvZBmOZhe2zqEtgkL9dHikDFVxSnj4gAxHVEg4mugAAIdEvAFaWTTlGLxbhkFLaIwOoixjsLwDQSaC2n1bDAcl4rl5AqEtGWjo/rqZMu5OJmzxYrbV6u6574OQiMlQDEdawji36BAAh0RmBIApuIaImFXOrndf00RWDT89JDupCrbFv9VWTcXaqpMZJGYXXtWfgBBeGudHf2UOPGINATAhDXngwEmgECIDA+AuJIaYVSWjq525B1rJ43CaxJNhsppyWMwKpt5EuEYUxcs9UoysrjJh0nl/yanugiEVjOaTVtSTu+NwU9AoHiBCCuxVnhkyAAAiAgIuASHOkUdZXrmlNk9XZbJI3AFoHVRkvXNI39MPzAGtX1iHgVPktrLkPAKbFSnq7zykZhObVhvkReq+hlw0mjJwBxHf0Qo4MgAAJ9IuCSnCYk1nZNaTktraQqF8v/vEgKgTE66hDYvBQvVwEFUbyXAqE+B9Yoa8nIdHZd19gWFViW1nxebp+eYbQFBLokAHHtkj7uDQIgcLAEXJIzFIHVyaY0hSAV0PSQ5sHydqj5KfYmWOoiyHUILFcR8FH66mC/F9BxNwGIq5sRPgECIAACjRGQ5lca5c4mftnP7GFWa197sZDL0PmYYlqs81p1nbBGnivkFUvFON9GLt3F27riAAEQMBOAuOLpAAEQAIGeEJBKbBPT3ja3NUUbTXmwqtjVWokgJ7BLP9xOsZcsBaY+AlKeJoF1Rdf53pyPyxsN6PJye/J4ohkg0AsCENdeDAMaAQIgAAJbAlKBbTsK6xI1Wx5s3Qu5VmFMPM2uPYQSKxVYk9jbxsdfhUleLg4QAAE7AYgrnhAQAAEQ6CkBqcC6Inyi65ZcsGRanJWhlkZhdTmwvJApm2KvcyHapq028S3JRXfNMOLSV9jStaevIZrVMwIQ154NCJoDAiAAAnkCThEVblkqEtg0nGg8dOJoSiHIRyalaQTJFHuuRUaBFYpmVYk1C3Wal4tYK957EChGAOJajBM+BQIgAAKdExiSwOalNPm7Io3SNIK8AK6CkEJHYqhEYqssuCrzCwFXQEDpq85fLTRgQAQgrgMaLDQVBEAABApF/oQR2Lxc7kV+zbsWWAdGGoV1RWB5il0tHVVGGHcaXDKCXGQMXCz551y6i3fIwgECIFCcAMS1OCt8EgRAAAR6R0Asa02Ufyo5DV80AmuSQF7QpJtirxKZLpsGUURide3h3b2Q19q71wkNGgABiOsABglNBAEQAAEXgV4JbGKa5haXjcCml0svmPWTI5UcsXRFNsVcSra/rMByigBKX7meavwcBPYJQFzxVIAACIDAiAiIRa2JCGwFgTUJKQssC6uu9JW0fFXblQg4xSEIsRxrRK8dutIiAYhri7BxKxAAARBoi0CV6XKpAKqR0b1+lkwjUMVVbQ9HKV15odL2NyGweQHnhViu9rf1jOA+IDBEAhDXIY4a2gwCIAACJQhIo7BO+ZVMp1cUWD/YnWKXrv539k2wEM21pSwPGVdBQKy1xMOLj4JAjgDEFY8ECIAACBwIAanA5qOGeVyi6woENoq3ea17bRBWUmhCYE2RZ05vQOmrA3nZ0M3GCHh37r25JI9OGrsDLgwCIAACINArAiLRXPdAOg1vkrnksgUit7wKf7Xe0rWL9ldNI2BhNW5J26unA40BgR4TiMnniOs/ieijPW4mmgYCIAACINAAAXG0sYOFXEEQ7e+OJYjaZhilAi4SWM7LXUt3A8OIS4LAIRH4l3f73hvveJ730iH1Gn0FARAAARDYJSCNYkoFsEwENkym2M0j1oWAl2k/R1pR+gpvHAhUJxDH4bve7a//6Ife5OR+9cvhCiAAAiAAAkMn0DeB5RSBMqWjmmh/IqkF0hl0Y88pAlm92aE/G2g/CHRNIA78B97Nl1+/O71+47ddNwb3BwEQAAEQ6A8BaRTTeV4JAYypnLSq9KSiWWv7WbptoeL+DDdaAgKDIBBc/PuuR3Tj+p1Xf/BHIu/Tg2g1GgkCIAACINAaAakAOqOUBQQ2iKpPsTtFtIFqBFkebJIi0NpI4UYgMHYC8ft/+vG3P8NfHdduvfLgK5PTF3429i6jfyAAAiAAAjICTQmgSXB5ij2KZG3VndVU+03X5baj9FV944crgUCweP61h2/d/yWL61UiOrp976e/87yjF4EGBEAABEAABGwEpFFYpzyuo7C8kKmpvFBnG4QRWFXAOS8XRQTwDoFAfQTiOHrvzz/55heIKOKviTMW10988TufvPbxW78noo/UdytcCQRAAARAYKwEpAJrirJm/x6GnN3a/CFtv6uSQpnFZM33EncAgcET+ODy7w8//7fffP+vmbiesrjyosmbL7/+uen1G78mwoYEgx9mdAAEQAAEWiIgFUCdwPL0etulo6Tt150XRe1Id0tDi9uAQNcE/NX54y89evu1PxAlv88mEVcWV/5v8mctrz9H5LXrscL9QQAEQGBYBKpOw/MUe5eL8Ife/mE9LWgtCDgJfLA6f/xVRVpZXGOW1SuquPL/5rSBqx/71BvIeXVCxQdAAARAAARyBKQC2KfFTOWjsN1KNx5CEBgTAc5pnf3jL99Ypwckwpr9YXE9yYtr9vdbrzz48uT0+ndRKmtMjwP6AgIgAALtESgqgH2SVpXO0Nvf3kjjTiBQB4H4/WBx/r2Hb93/lSqreXGd5sSV77xJHSC6cXTz5dc+Ozl74b/pePqi53k3KaYPk4c82DqGCNcAARAAgUMgYI3Cxmk4pc/H0NvfZ7Zo24ESiMknj57EcfyIwtV7wfz5/z96+/V3iB5zITw1ysqANn//D4dDwb5KfI/aAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  padding: 0 0.14rem;
  overflow: hidden;
  height: 0.44rem;
  border-radius: 0.07rem;
  -webkit-box-shadow: 0 0 0.09rem 0.03rem RGBA(0, 0, 0, 0.12);
  box-shadow: 0 0 0.09rem 0.03rem RGBA(0, 0, 0, 0.12);
}

.sy-accordion .sy-accordion-content {
  padding: 0.2rem 0.08rem 0;
}

blockquote,
body,
button,
dd,
dl,
dt,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
iframe,
img,
input,
legend,
li,
ol,
p,
pre,
td,
textarea,
th,
ul {
  margin: 0;
  padding: 0;
}

p {
  text-align: left;
}

.topLine {
  margin-top: 0.8rem;
}

.sy-title .sy-title-divider {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: left;
  -ms-flex-pack: left;
  justify-content: left;
  -webkit-box-align: left;
  -ms-flex-align: left;
  align-items: left;
  text-align: left;
  color: RGBA(51, 51, 51, 1);
  font-weight: bold;
  font-size:0.9rem;
  margin-bottom: 0.1rem;
}

.sy-title .sy-title-divider:before {
  display: inline-block;
  width: 0.2rem;
  height: 1rem;
  background: #1890ff;
  content: '';
}

*,
:after,
:before {
  box-sizing: border-box;
  outline: 0;
}

.user {
  margin-top: 1.2rem;
  margin-bottom: 0.08rem;
  display: flex;
  height: 3rem;
  border-radius: 0.04rem;
  background: rgba(5, 155, 243, 0.1);
}

.user .user-item {
  width: 0.5rem;
  padding-left: 0.8rem;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.user .user-item img {
  margin-right: 0.08rem;
  width: 1.2rem;
  height: 1.2rem;
  vertical-align: middle;
}

.area-block {
  bottom: 0;
  width: 100%;
  left: 0;
  height: 4rem;
  padding: 1.4rem 0;
  background: #dee4eb;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.area-block span {
  font-size: 0.8rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1E5792;
}
.swipe-title {
    position: absolute;
    bottom: 0.27rem;
    color: #fff;
    font-size: 0.63rem;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0.11rem;
    margin-bottom: 0.1rem;
    margin-left: 1.3rem;
    padding-left:0.2rem;
    padding-right: 0.2rem;
}


     .van-collapse-item__title {
      background-color: transparent !important;
    }

    .van-collapse-item{
      background-color: #e6f7ff;
      border-left: 4px solid #1890ff;
      margin-bottom: .2rem;
      border-radius: .4rem;
      font-size: 1.2rem;
      overflow: hidden;
    }

    .van-cell__value {
      font-size: 0.8rem;
    }

.copyright {
  padding: 0.5rem 1rem;
  text-align: center;
  background: #fff;
  border-top: 1px solid #ebedf0;
  z-index: 10;
}

.copyright p {
  margin: 2px 0;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  text-align: center;

}
</style>
  